import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const PioneerList = () => {
  const [pioneers, setPioneers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewedDetails, setViewedDetails] = useState(null);
  const [replyDetails, setReplyDetails] = useState(null);
  const [updatingStatusId, setUpdatingStatusId] = useState(null);
  const [replyLoading, setReplyLoading] = useState(false);
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [addressDetails, setAddressDetails] = useState(null);
  const [address, setAddress] = useState("");
  const [addressLoading, setAddressLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState("all");


  // useEffect(() => {
  //   fetchPioneers();
  // }, []);

useEffect(() => {
  setCurrentPage(1);
  fetchPioneers(1, statusFilter);
}, [statusFilter]);


  const fetchPioneers = async (page = 1, status = statusFilter) => {
  setLoading(true);
  try {
    const token = localStorage.getItem("token");
    const filterParam = status !== "all" ? `&status=${status}` : "";
    const res = await fetch(`${baseUrl}/pioneer/request-list?page=${page}${filterParam}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const result = await res.json();
    if (result.status) {
      setPioneers(result.data);
      setCurrentPage(result.pagination.currentPage);
      setLastPage(result.pagination.lastPage);
    } else {
      toast.error(result.message || "Failed to fetch pioneer list.");
    }
  } catch (error) {
    toast.error("Network error while fetching list.");
  } finally {
    setLoading(false);
  }
};


  const getStatusColor = (status) => {
    switch (status) {
      case "approved":
        return "text-green-600 bg-green-100";
      case "rejected":
        return "text-red-600 bg-red-100";
      default:
        return "text-orange-600 bg-orange-100";
    }
  };

  const viewDetails = async (id) => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${baseUrl}/pioneer/request-list/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const result = await res.json();
      if (res.ok) {
        setViewedDetails(result.data);
      } else {
        toast.error("Failed to load details");
      }
    } catch {
      toast.error("Error loading user details");
    }
  };

  const updateStatus = async (id, status) => {
    setUpdatingStatusId(id);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${baseUrl}/pioneer/request/status/${id}`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ status }),
      });
      // const result = await res.json();
      if (res.ok) {
        toast.success(`Status updated to ${status}`);
        fetchPioneers();
      } else {
        toast.error("Failed to update status");
      }
    } catch {
      toast.error("Error updating status");
    } finally {
      setUpdatingStatusId(null);
    }
  };

  const sendReply = async () => {
    if (!replyDetails?.email || !subject || !message) {
      toast.error("All fields are required");
      return;
    }

    setReplyLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${baseUrl}/pioneer/request/replay/${replyDetails.id}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: replyDetails.email,
          subject,
          message,
        }),
      });
      const result = await res.json();
      if (res.ok) {
        toast.success("Reply sent successfully");
        setReplyDetails(null);
        setSubject();
        setMessage();
      } else {
        toast.error(result.message || "Failed to send reply");
      }
    } catch {
      toast.error("Error sending reply");
    } finally {
      setReplyLoading(false);
    }
  };

  // address update
  const openAddressModal = (user) => {
    setAddressDetails(user);
    setAddress("");
  };

  const handleAddressSubmit = async () => {
    if (!address) {
      toast.error("Address cannot be empty");
      return;
    }

    setAddressLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${baseUrl}/pioneer/request/address/${addressDetails.id}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ address }),
      });

      const result = await res.json();
      if (res.ok) {
        toast.success("Address added successfully");
        setAddressDetails(null);
        fetchPioneers();
      } else {
        toast.error(result.message || "Failed to add address");
      }
    } catch {
      toast.error("Network error");
    } finally {
      setAddressLoading(false);
    }
  };

  // get days difference
  const getDaysSinceUserCreated = (userCreatedAt) => {
  const createdDate = new Date(userCreatedAt);
  const today = new Date();

  const diffTime = Math.abs(today - createdDate); // Difference in milliseconds
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)); // Convert to full days

  return diffDays;
};


  return (
    <div className="flex bg-gray-100 min-h-screen">
      <Sidebar />
      <div className="flex-1 flex flex-col">
        <Navbar />
        <div className="p-6">
          <Toaster position="top-right" />
          <h1 className="text-2xl font-bold mb-6">Pioneer Request List</h1>

          {loading ? (
            <p>Loading...</p>
          ) : (
            <div className="overflow-x-auto">
              <div className="mb-4 flex items-center space-x-2">
                <label className="font-medium">Filter by Status:</label>
                <select
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  className="border px-3 py-2 rounded"
                >
                  <option value="all">All</option>
                  <option value="approved">Approved</option>
                  <option value="rejected">Rejected</option>
                  <option value="pending">Pending</option>
                </select>
              </div>

              <table className="min-w-full bg-white shadow border rounded text-sm">
                <thead className="bg-gray-100 text-gray-700 text-left">
                  <tr>
                    <th className="p-3">#</th>
                    <th className="p-3">Create Date</th>
                    <th className="p-3">Request Date</th>
                    <th className="p-3">Days</th>
                    <th className="p-3">Name</th>
                    <th className="p-3">Email</th>
                    <th className="p-3">Country</th>
                    <th className="p-3">Profession</th>
                    <th className="p-3">Refer Count</th>
                    <th className="p-3">Status</th>
                    <th className="p-3 text-center">Actions</th>
                    <th className="p-3 text-center">Reply</th>
                    <th className="p-3 text-center">Address</th>
                  </tr>
                </thead>
                <tbody>
                  {pioneers
                  .filter((item) => statusFilter === "all" || item.status === statusFilter)
                  .map((item, index) => (
                    
                    <tr key={item.id} className="border-b">
                      <td className="p-3">{index + 1}</td>
                      <td className="p-3">{new Date(item.userCreatedAt).toLocaleDateString()}</td>
                      <td className="p-3">{new Date(item.createdAt).toLocaleDateString()}</td>
                      <td className="p-3"> {getDaysSinceUserCreated(item.userCreatedAt)}</td>
                      <td className="p-3">{item.firstName} {item.lastName}</td>
                      <td className="p-3">{item.email}</td>
                      <td className="p-3">{item.country}</td>
                      <td className="p-3">{item.profession}</td>
                      <td className="p-3">{item.referCount}</td>
                      <td className={`p-3 font-medium text-center rounded ${getStatusColor(item.status)}`}>
                        {item.status}
                      </td>
                      <td className="p-3 space-x-2 text-center">
                        <button onClick={() => viewDetails(item.id)} className="text-blue-600 hover:underline">View</button>
                        <button disabled={updatingStatusId === item.id} onClick={() => updateStatus(item.id, "approved")} className="text-green-600 hover:underline">Approve</button>
                        <button disabled={updatingStatusId === item.id} onClick={() => updateStatus(item.id, "rejected")} className="text-red-600 hover:underline">Reject</button>
                      </td>
                      <td className="p-3 text-center">
                        <button onClick={() => setReplyDetails(item)} className="text-indigo-600 hover:underline">Reply</button>
                      </td>
                      <td className="p-3 text-center">
                        <button onClick={() => openAddressModal(item)} className="text-purple-600 hover:underline">Add Address</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="flex justify-center mt-4 space-x-2">
                <button
                  onClick={() => fetchPioneers(currentPage - 1, statusFilter)}
                  disabled={currentPage === 1}
                  className="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
                >
                  Prev
                </button>
                {Array.from({ length: lastPage }, (_, i) => (
                  <button
                    key={i}
                    onClick={() => fetchPioneers(i + 1, statusFilter)}
                    className={`px-3 py-1 rounded ${currentPage === i + 1 ? "bg-blue-600 text-white" : "bg-gray-200 hover:bg-gray-300"}`}
                  >
                    {i + 1}
                  </button>
                ))}
                <button
                  onClick={() => fetchPioneers(currentPage + 1, statusFilter)}
                  disabled={currentPage === lastPage}
                  className="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
                >
                  Next
                </button>
              </div>

            </div>
          )}

          {/* View Details Popup */}
          {viewedDetails && (
            <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
              <div className="bg-white w-full max-w-lg p-6 rounded shadow-lg relative">
                <button className="absolute top-2 right-3 text-gray-600 text-xl" onClick={() => setViewedDetails(null)}>&times;</button>
                <h2 className="text-xl font-bold mb-4">Pioneer Details</h2>
                <div className="text-sm space-y-2">
                  <p><strong>Name:</strong> {viewedDetails.firstName} {viewedDetails.lastName}</p>
                  <p><strong>Email:</strong> {viewedDetails.email}</p>
                  <p><strong>Country:</strong> {viewedDetails.country}</p>
                  <p><strong>Profession:</strong> {viewedDetails.profession}</p>
                  <p><strong>URL:</strong> <a href={viewedDetails.url} target="_blank" rel="noreferrer" className="text-blue-600 underline">{viewedDetails.url}</a></p>
                  <p><strong>Message:</strong> {viewedDetails.message}</p>
                  <p><strong>Status:</strong> {viewedDetails.status}</p>
                  <p><strong>Applied On:</strong> {new Date(viewedDetails.createdAt).toLocaleString()}</p>
                  <p><strong>Address:</strong> {viewedDetails.address}</p>
                </div>
                <div className="mt-4 text-right">
                  <button onClick={() => setViewedDetails(null)} className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">Close</button>
                </div>
              </div>
            </div>
          )}

          {/* Reply Popup */}
          {replyDetails && (
            <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
              <div className="bg-white w-full max-w-xl p-6 rounded shadow-lg relative">
                <button className="absolute top-2 right-3 text-gray-600 text-xl" onClick={() => setReplyDetails(null)}>&times;</button>
                <h2 className="text-xl font-bold mb-4">Reply to Pioneer</h2>
                <div className="space-y-3">
                  <input type="text" disabled value={replyDetails.email} className="w-full border px-3 py-2 rounded bg-gray-100" />
                  <input type="text" value={subject} onChange={(e) => setSubject(e.target.value)} className="w-full border px-3 py-2 rounded" placeholder="Subject" />
                   <ReactQuill
                      value={message}
                      onChange={setMessage}
                      placeholder="Write your reply..."
                      className="bg-white"
                      style={{ height: "200px" }}
                    />
                </div>
                <div className="mt-4 text-right" style={{marginTop: "4rem"}}>
                  <button onClick={sendReply} disabled={replyLoading} className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700">
                    {replyLoading ? "Sending..." : "Send Reply"}
                  </button>
                </div>
              </div>
            </div>
          )}


          {/* Address Modal */}
          {addressDetails && (
            <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
              <div className="bg-white w-full max-w-lg p-6 rounded shadow relative">
                <button
                  className="absolute top-2 right-3 text-gray-600 text-xl"
                  onClick={() => setAddressDetails(null)}
                >
                  &times;
                </button>
                <h2 className="text-xl font-bold mb-4">Add Address for {addressDetails.email}</h2>
                <textarea
                  rows="4"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  placeholder="Enter address"
                  className="w-full border px-3 py-2 rounded"
                />
                <div className="mt-4 text-right">
                  <button
                    onClick={handleAddressSubmit}
                    disabled={addressLoading}
                    className="bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700"
                  >
                    {addressLoading ? "Saving..." : "Save Address"}
                  </button>
                </div>
              </div>
            </div>
          )}


        </div>
      </div>
    </div>
  );
};

export default PioneerList;
